// extracted by css-extract-rspack-plugin
export default {"HeaderEditorContainer":"HeaderEditor-module__HeaderEditorContainer__lV4haeX"};